/**
 * Created by why on 2019/10/21.
 */
import {
  getByCondition,
  save,
  edit,
  delByIds,
  getByTicketTypeCount,
  getByPlayTypeCount,
  getByMoneyCount,
  getBettingTrend
} from '@/api/betting-record-manage'
import dayJs from 'dayjs'
export default {
  state: {
    list: [],
    loading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    orderNum: 0,
    total: 0,
    play: {
      playList: [],
      bettingList: [],
      bonusList: [],
      ticketList: [],
      ticketType: '竞彩足球',
      loseMoneyList: [],
      prizeCountList: [],
      notPrizeCountList: [],
      sumPrizeCountList: [],
      returnRate: [],
      winningRateList: [],
      playTime: 'all',
      playTimeType: 'year',
      playTimeValue: dayJs(new Date()).format('YYYY'),
      isHiddenPlayTime: true,
      playTimeList: [{title: '全部', value: 'all'}, {title: '年份', value: 'year'}, {title: '月份', value: 'month'}]
    },
    ticket: {
      bettingList: [],
      bonusList: [],
      ticketList: [],
      returnRate: [],
      loseMoneyList: [],
      prizeCountList: [],
      notPrizeCountList: [],
      sumPrizeCountList: [],
      winningRateList: [],
      playTime: 'all',
      playTimeType: 'year',
      playTimeValue: dayJs(new Date()).format('YYYY'),
      isHiddenPlayTime: true,
      playTimeList: [{title: '全部', value: 'all'}, {title: '年份', value: 'year'}, {title: '月份', value: 'month'}]
    }
  },
  mutations: {
    setRecordList (state, list) {
      state.list = list
    },
    setRecordLoading (state, loading) {
      state.loading = loading
    },
    setRecordPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setRecordPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setRecordTotal (state, total) {
      state.total = total
    },
    setRecordLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    },
    setPlayList (state, playList) {
      state.play.playList = playList
    },
    setBettingList (state, bettingList) {
      state.play.bettingList = bettingList
    },
    setBonusList (state, bonusList) {
      state.play.bonusList = bonusList
    },
    setTicketType (state, ticketType) {
      state.play.ticketType = ticketType
    },
    setPlayTicketList (state, ticketList) {
      state.play.ticketList = ticketList
    },
    setLoseMoneyList (state, loseMoneyList) {
      state.play.loseMoneyList = loseMoneyList
    },
    setPrizeCountList (state, prizeCountList) {
      state.play.prizeCountList = prizeCountList
    },
    setNotPrizeCountList (state, notPrizeCountList) {
      state.play.notPrizeCountList = notPrizeCountList
    },
    setSumPrizeCountList (state, sumPrizeCountList) {
      state.play.sumPrizeCountList = sumPrizeCountList
    },
    setWinningRateList (state, winningRateList) {
      state.play.winningRateList = winningRateList
    },
    setReturnRate (state, returnRate) {
      state.play.returnRate = returnRate
    },
    setPlayTimeType (state, playTimeType) {
      state.play.playTimeType = playTimeType
    },
    setPlayTimeValue (state, playTimeValue) {
      state.play.playTimeValue = playTimeValue
    },
    setIsHiddenPlayTime (state, isHiddenPlayTime) {
      state.play.isHiddenPlayTime = isHiddenPlayTime
    },
    setPlayTime (state, playTime) {
      state.play.playTime = playTime
    },
    setTicketBettingList (state, bettingList) {
      state.ticket.bettingList = bettingList
    },
    setTicketBonusList (state, bonusList) {
      state.ticket.bonusList = bonusList
    },
    setTicketReturnRate (state, returnRate) {
      state.ticket.returnRate = returnRate
    },
    setTicketLoseMoneyList (state, loseMoneyList) {
      state.ticket.loseMoneyList = loseMoneyList
    },
    setTicketPrizeCountList (state, prizeCountList) {
      state.ticket.prizeCountList = prizeCountList
    },
    setTicketNotPrizeCountList (state, notPrizeCountList) {
      state.ticket.notPrizeCountList = notPrizeCountList
    },
    setTicketSumPrizeCountList (state, sumPrizeCountList) {
      state.ticket.sumPrizeCountList = sumPrizeCountList
    },
    setTicketWinningRateList (state, winningRateList) {
      state.ticket.winningRateList = winningRateList
    },
    setTicketPlayTimeType (state, playTimeType) {
      state.ticket.playTimeType = playTimeType
    },
    setTicketPlayTimeValue (state, playTimeValue) {
      state.ticket.playTimeValue = playTimeValue
    },
    setTicketIsHiddenPlayTime (state, isHiddenPlayTime) {
      state.ticket.isHiddenPlayTime = isHiddenPlayTime
    },
    setTicketList (state, ticketList) {
      state.ticket.ticketList = ticketList
    },
    setTicketPlayTime (state, playTime) {
      state.ticket.playTime = playTime
    }
  },
  getters: {
    recordList: state => state.list,
    orderNum: state => state.orderNum,
    recordTotal: state => state.total,
    recordPageNum: state => state.pageNum,
    recordPageSize: state => state.pageSize,
    recordLoading: state => state.loading,
    recordLoadingSave: state => state.loadingSave,
    playList: state => state.play.playList,
    bettingList: state => state.play.bettingList,
    bonusList: state => state.play.bonusList,
    loseMoneyList: state => state.play.loseMoneyList,
    prizeCountList: state => state.play.prizeCountList,
    notPrizeCountList: state => state.play.notPrizeCountList,
    sumPrizeCountList: state => state.play.sumPrizeCountList,
    winningRateList: state => state.play.winningRateList,
    returnRate: state => state.play.returnRate,
    playTime: state => state.play.playTime,
    playTicketList: state => state.play.ticketList,
    ticketType: state => state.play.ticketType,
    playTimeList: state => state.play.playTimeList,
    playTimeType: state => state.play.playTimeType,
    playTimeValue: state => state.play.playTimeValue,
    isHiddenPlayTime: state => state.play.isHiddenPlayTime,
    ticketBonusList: state => state.ticket.bonusList,
    ticketList: state => state.ticket.ticketList,
    ticketBettingList: state => state.ticket.bettingList,
    ticketLoseMoneyList: state => state.ticket.loseMoneyList,
    ticketReturnRate: state => state.ticket.returnRate,
    ticketPrizeCountList: state => state.ticket.prizeCountList,
    ticketNotPrizeCountList: state => state.ticket.notPrizeCountList,
    ticketSumPrizeCountList: state => state.ticket.sumPrizeCountList,
    ticketWinningRateList: state => state.ticket.winningRateList,
    ticketPlayTimeType: state => state.ticket.playTimeType,
    ticketPlayTimeValue: state => state.ticket.playTimeValue,
    ticketIsHiddenPlayTime: state => state.ticket.isHiddenPlayTime,
    ticketPlayTimeList: state => state.ticket.playTimeList,
    ticketPlayTime: state => state.ticket.playTime
  },
  actions: {
    getRecordByCondition ({ state, commit }, data) {
      commit('setRecordLoading', true)
      return new Promise((resolve, reject) => {
        getByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records.sort((a, b) => {
            return a.cost < b.cost ? 1 : -1
          })
          const pageSize = data.size
          const pageNum = data.current
          const total = data.total
          commit('setRecordList', list)
          commit('setRecordLoading', false)
          commit('setRecordPageSize', pageSize)
          commit('setRecordPageNum', pageNum)
          commit('setRecordTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setRecordLoading', false)
          reject(err)
        })
      })
    },
    recordInsert ({ state, commit }, data) {
      commit('setRecordLoadingSave', true)
      return new Promise((resolve, reject) => {
        save(data).then(res => {
          commit('setRecordLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setRecordLoadingSave', false)
          reject(err)
        })
      })
    },
    recordDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        delByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    recordEdit ({ state, commit }, data) {
      commit('setRecordLoadingSave', true)
      return new Promise((resolve, reject) => {
        edit(data).then(res => {
          commit('setRecordLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setRecordLoadingSave', false)
          reject(err)
        })
      })
    },
    getByMoneyCount ({ state, commit }) {
      return new Promise((resolve, reject) => {
        getByMoneyCount().then(res => {
          const result = res.data.result
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getBettingTrend ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getBettingTrend(data).then(res => {
          const result = res.data.result
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getByPlayTypeCount ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getByPlayTypeCount(data).then(res => {
          const result = res.data.result
          commit('setPlayList', result.playList)
          commit('setBettingList', result.bettingList)
          commit('setBonusList', result.bonusList)
          commit('setLoseMoneyList', result.loseMoneyList)
          commit('setPrizeCountList', result.prizeCountList)
          commit('setNotPrizeCountList', result.notPrizeCountList)
          commit('setSumPrizeCountList', result.sumPrizeCountList)
          commit('setReturnRate', result.returnRate)
          commit('setWinningRateList', result.winningRateList)
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getByTicketTypeCount ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getByTicketTypeCount(data).then(res => {
          const result = res.data.result
          commit('setTicketBettingList', result.bettingList)
          commit('setTicketBonusList', result.bonusList)
          commit('setTicketList', result.ticketList)
          commit('setTicketReturnRate', result.returnRate)
          commit('setTicketLoseMoneyList', result.loseMoneyList)
          commit('setTicketPrizeCountList', result.prizeCountList)
          commit('setTicketNotPrizeCountList', result.notPrizeCountList)
          commit('setTicketSumPrizeCountList', result.sumPrizeCountList)
          commit('setTicketWinningRateList', result.winningRateList)
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setParam ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        const key = data.key
        const value = data.value
        switch (key) {
          case 'ticketType':
            commit('setTicketType', value)
            break
          case 'playTimeList':
            commit('setPlayTimeList', value)
            break
          case 'playTimeType':
            commit('setPlayTimeType', value)
            break
          case 'playTimeValue':
            commit('setPlayTimeValue', value)
            break
          case 'isHiddenPlayTime':
            commit('setIsHiddenPlayTime', value)
            break
        }
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/betting-record-manage.js